import { render, staticRenderFns } from "./WCompanyPicEdit.vue?vue&type=template&id=0a5ff66d&"
import script from "./WCompanyPicEdit.vue?vue&type=script&lang=ts&"
export * from "./WCompanyPicEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports